// material-ui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const miningBackgroundUrl = '/src/assets/images/mineacs/login-mining-background.jpg';
const devicePreviewUrl = '/src/assets/images/mineacs/mineacs-device-preview.png';

export default function LoginHeroPanel() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        color: 'common.white',
        backgroundImage: `linear-gradient(0deg, rgba(5, 7, 12, 0.76), rgba(5, 7, 12, 0.76)), linear-gradient(135deg, rgba(20, 20, 20, 0.96), rgba(87, 37, 34, 0.9)), url(${miningBackgroundUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'grayscale(1)',
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(circle at 52% 42%, rgba(229, 57, 53, 0.28), transparent 33%), linear-gradient(180deg, rgba(0,0,0,0.08), rgba(0,0,0,0.55))',
          zIndex: 0
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          filter: 'grayscale(0)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: { md: 5, xl: 8 },
          pb: { md: 12, xl: 7 },
          zIndex: 1
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: 'min(78%, 760px)',
            aspectRatio: '16 / 10',
            borderRadius: 4,
            p: 1.2,
            bgcolor: 'rgba(255,255,255,0.13)',
            boxShadow: '0 36px 120px rgba(0,0,0,0.56)',
            backdropFilter: 'blur(5px)',
            '&:before': {
              content: '""',
              position: 'absolute',
              inset: '8% 6% 14%',
              borderRadius: 3,
              backgroundImage: `url(${devicePreviewUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: 0.92,
              zIndex: 2
            },
            '&:after': {
              content: '""',
              position: 'absolute',
              left: '18%',
              right: '18%',
              bottom: '-7%',
              height: '8%',
              borderRadius: '0 0 26px 26px',
              bgcolor: 'rgba(20,20,20,0.9)',
              boxShadow: '0 18px 30px rgba(0,0,0,0.35)'
            }
          }}
        >
          <Box
            sx={{
              height: '100%',
              borderRadius: 3,
              border: '10px solid rgba(18, 18, 18, 0.95)',
              bgcolor: '#111',
              overflow: 'hidden',
              position: 'relative'
            }}
          >
            <Box sx={{ height: 28, bgcolor: '#20242a', display: 'flex', alignItems: 'center', px: 1.5, gap: 0.75 }}>
              {[0, 1, 2].map((item) => (
                <Box
                  key={item}
                  sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: item === 0 ? '#e53935' : 'rgba(255,255,255,0.3)' }}
                />
              ))}
            </Box>
            <Box
              sx={{
                height: 'calc(100% - 28px)',
                display: 'grid',
                gridTemplateColumns: '0.95fr 1.3fr',
                gap: 2,
                p: 2.25,
                background: 'linear-gradient(135deg, #171b22, #0f1116)'
              }}
            >
              <Stack sx={{ gap: 1.1 }}>
                <Box sx={{ width: '58%', height: 9, borderRadius: 5, bgcolor: '#e53935' }} />
                <Box sx={{ height: 62, borderRadius: 2, bgcolor: 'rgba(229,57,53,0.17)', border: '1px solid rgba(229,57,53,0.38)' }} />
                <Box sx={{ height: 62, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.08)' }} />
                <Box sx={{ height: 62, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.08)' }} />
              </Stack>
              <Box
                sx={{
                  borderRadius: 3,
                  border: '1px solid rgba(255,255,255,0.11)',
                  background:
                    'radial-gradient(circle at 45% 45%, rgba(229,57,53,0.55), transparent 5%), radial-gradient(circle at 62% 38%, rgba(255,255,255,0.36), transparent 4%), linear-gradient(145deg, rgba(74,82,92,0.55), rgba(21,25,33,0.95))'
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              position: 'absolute',
              right: '-8%',
              bottom: '-3%',
              width: '22%',
              minWidth: 96,
              aspectRatio: '9 / 18',
              borderRadius: 3,
              border: '8px solid #161616',
              bgcolor: '#111',
              boxShadow: '0 22px 55px rgba(0,0,0,0.45)',
              zIndex: 3,
              overflow: 'hidden'
            }}
          >
            <Box sx={{ height: '100%', p: 1, background: 'linear-gradient(180deg, #222832, #111318)' }}>
              <Stack sx={{ gap: 1 }}>
                <Box sx={{ width: '54%', height: 7, borderRadius: 3, bgcolor: '#e53935' }} />
                <Box sx={{ height: 45, borderRadius: 1.5, bgcolor: 'rgba(229,57,53,0.2)' }} />
                <Box sx={{ height: 9, borderRadius: 3, bgcolor: 'rgba(255,255,255,0.22)' }} />
                <Box sx={{ height: 9, borderRadius: 3, bgcolor: 'rgba(255,255,255,0.16)' }} />
                <Box sx={{ height: 68, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.08)' }} />
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>

      <Stack
        sx={{
          position: 'absolute',
          left: { md: 42, lg: 58 },
          right: { md: 42, lg: 58 },
          bottom: { md: 42, lg: 58 },
          gap: 1.7,
          maxWidth: 680,
          filter: 'grayscale(0)',
          zIndex: 2
        }}
      >
        <Typography variant="h2" sx={{ color: 'inherit', fontWeight: 800, lineHeight: 1.08, letterSpacing: -0.8 }}>
          Kelola Keselamatan Tambang
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.78)', fontSize: 16, lineHeight: 1.8 }}>
          Pantau perangkat UWB, posisi unit, telemetry, dan safety event secara real-time dalam satu sistem operasional MineACS.
        </Typography>
      </Stack>
    </Box>
  );
}
